import React, { useState, useRef, useEffect } from "react"
import { TabView, TabPanel } from "primereact/tabview"
import { CardBody, Col, Container, Row, DropdownItem, DropdownMenu, Input, InputGroup, InputGroupText, } from "reactstrap"
// import { Col, Row } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { MultiSelect } from "primereact/multiselect"
import { useForm } from "react-hook-form"
import { useLocation } from "react-router-dom"
import axios from "axios"
import moment from "moment"
import { emailValidation, MaxLengthValidation, MinLengthValidation, onlyAlphabetsandSpaces, onlyNumbers, passwordPattern } from "utils/Constants"
import Modal from "react-bootstrap/Modal";
import { TreeSelect } from 'primereact/treeselect';
import { Eye, EyeOff } from 'lucide-react';
import { InputTextarea } from "primereact/inputtextarea"
import AdminDasboardats from "ATSComponents/Common/AdminDasboardats"
import Rolesadmin from "./Rolesadmin"
import User_groups_admin from "./User_groups_admin"
import { setPageData } from "store/actions"
import { useDispatch, useSelector } from "react-redux"
import { size } from "lodash"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import { FaTimes } from "react-icons/fa"
const User_managment = ({ type, onclicks }) => {
    const location = useLocation()
    const dispatch = useDispatch();
    const { first, rows, totalRecords } = useSelector(state => state.calendar.pagination);
    document.title = "ATS - Admin"
    const dt = useRef(null);
    const skipEffectsDuringEdit = useRef(false);
    const [addressLabels, setAddressLabels] = useState([]);
    const [lazyParamsuser, setLazyParamsuser] = useState({ page: 0, rows: 10 });
    const [totalRecordsuser, setTotalRecordsuser] = useState(0); 
    const [isLoading, setIsLoading] = useState(false)
    const [street1, setStreet1] = useState('');
    const [street2, setStreet2] = useState('')
    const [selectedCity, setSelectedCity] = useState(null);
    const [addCountries, setAddCountries] = useState([]);
    const [addStates, setAddStates] = useState([]);
    const [addCities, setAddCities] = useState([]);
    const [selectedState, setSelectedState] = useState(null)
    const [searchQuery, setSearchQuery] = useState("");

    const [postalCode, setPostalCode] = useState('');
    const [userRoles, setUserRoles] = useState([])
    const [selectedLabel1, setSelectedLabel1] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [groupitem, setgroupitem] = useState([])
    const [selectedGroupKey, setSelectedGroupKey] = useState(null);
    const [categoriesitem, setcategoriesitem] = useState([])
    const { register, handleSubmit, watch, formState: { errors }, trigger, control, setValue, reset } = useForm();
    const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);
    const [pagegroup, setpagegroup] = useState({ page: 0, rows: 10 });
    const [totalRecords1, setTotalRecords1] = useState(0);
    const [visible, setVisible] = useState(false)
    const [address, setAddress] = useState("")
    const [userList, setUserList] = useState([])
    const [formVisible, setFormVisible] = useState(false) // Controls the form visibility
    const [isEditMode, setIsEditMode] = useState(null) // True when editing, false when adding
    const [isEditModegrop, setIsEditModegrop] = useState(null) // True when editing, false when adding
    const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);
    const formattedAddress = [

        street1 || "",
        street2 || "",
        selectedCity?.name || selectedCity || "",
        selectedState?.name || selectedState || "",
        selectedCountry?.name || selectedCountry || "",
        postalCode || "",
        selectedLabel1?.name || selectedLabel1 || ""
    ]
        .filter(Boolean) // Removes empty strings
        .join(",\n");     // Joins each part with a newline


    const resetForm = () => {
        reset()
        setFormVisible(false) // Hide the form
        setIsEditMode(null)
    }



    /////////////////////////////////////////////// Sahitis Code /////////////////////////////////////////////////////////////// 

    const [loading, setLoading] = useState(false);
    const [smShowuser, setSmShowuser] = useState(false)
    const [smShowcreate, setSmShowcreate] = useState(false)
    const [smcreate, setsmcreate] = useState("Added")
    const [successAlert, setSuccessAlert] = useState(false);
    const [deleteRowIduser, setDeleteRowIDuser] = useState(null)
    const [showPassword, setShowPassword] = useState(false);


    const labels = [
        { name: 'Work ', code: 'WORK' },
        { name: 'Home', code: 'HOME' },
        { name: 'Other', code: 'Other' },
    ];

    const getaddCountries = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-countries/`, {});
            const transformedData = response.data.results.map((Countries) => ({
                name: Countries.name,
                id: Countries.country_id,
            }));
            setAddCountries(transformedData);
            // //console.log(transformedData)

        }
        catch (error) {
        }
    };
    const fetchAddressLabels = async () => {
        try {
            const response = await axios.get("/api/v1/get-all-address-label/");
            if (response.data && response.data.results) {
                setAddressLabels(
                    response.data.results.map(label => ({
                        name: label.address_label,
                        id: label.id,
                    }))
                );
            }
        } catch (error) {
            setAddressLabels([]);
        }
    };


    const getaddStates = async (countryId) => {
        try {
            const response = await axios.get(`/api/v1/get-all-states/?country_id=${countryId}`, {});
            const transformedData = response.data.results.map((city) => ({
                name: city.name,
                id: city.state_id,
            }));
            setAddStates(transformedData);

        }
        catch (error) {
        }
    };
    const getaddCities = async (stateId) => {
        try {
            const response = await axios.get(`/api/v1/get-all-cities/?state_id=${stateId}`, {});
            const transformedData = response.data.results.map((city) => ({
                name: city.name,
                id: city.city_id,
            }));
            setAddCities(transformedData);
        }
        catch (error) {
        }
    };

    const [rolesval, setrolesval] = useState()

    const fetchUserRoles = async () => {
        try {
            const response = await axios.get(`api/v1/get-all-roles/?company_id=${companyId}`)
            const transformedDataroles = response.data.results.map((city) => ({
                name: city.role_name,
                id: city.role_id,
            }));
            setUserRoles(transformedDataroles);

        }
        catch (error) {
            //console.log('error occured ', error.message)
        }
    }
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [department, setdepartment] = useState(null);
    const [companies, setcompanies] = useState([])
    const [departmentslist, setdepartmentslist] = useState([])

    const fetchAllCompanies = async () => {
        try {
            const response = await axios.get(`api/v1/get-all-companies/`)
            const transformedDataroles = response.data.results.map((city) => ({
                name: city.company_name,
                id: city.company_id,
            }));
            setcompanies(transformedDataroles);

        }
        catch (error) {
            //console.log('error occured ', error.message)
        }
    }
    const fetchAllDepartments = async () => {
        try {
            const response = await axios.get(`api/v1/get-all-departments/`)
            const transformedDataroles = response.data.results.map((city) => ({
                name: city.name,
                id: city.department_id,
            }));
            setdepartmentslist(transformedDataroles);
        }
        catch (error) {
            //console.log('error occured ', error.message)
        }
    }


    const [relatedPerson, setRelatedPerson] = useState([]);
    const [relatedPersonlist, setrelatedPersonlist] = useState(null);

    const getRelatedPersons = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-hiring-managers/`);
            const transformedDataroles = response.data.results.map((item) => ({
                id: item.id,
                name: `${item.first_name || ""}`
            }));

            setRelatedPerson(transformedDataroles);


        }
        catch (error) {
            // console.log("Failed to fetch related persons", error);
        }
    }

    useEffect(() => {
        getRelatedPersons()
        fetchAddressLabels();
    }, [])


    // Handle edit
    const handleEditUser = async (rowData) => {

        console.log(rowData)


        setIsEditMode(rowData?.id)

        setValue('user_id', rowData.user_id);
        setValue('email', rowData.email);
        setValue('password', rowData.watch_word);
        setValue("role_id", rowData.role_id, { shouldValidate: true }); // Ensure validation runs
        // setValue('company', rowData.company);
        setValue('first_name', rowData.first_name);
        setValue('middle_name', rowData.middle_name);
        setValue('last_name', rowData.last_name);
        setValue('phone_number', rowData.phone_number);
        setValue('job_title', rowData.job_title);
        // setValue('department', rowData.department);
        // setValue('category', rowData.category);
        // setValue('group', rowData.group);
        setStreet1(rowData.street_address);
        setStreet2(rowData.street_address_line_2);
        //    setSelectedLabel1(rowData.label);
        setPostalCode(rowData.pincode);
        // setSelectedCountry(rowData.country_name)
        // setSelectedState(rowData.state_name)
        // setSelectedCity(rowData.city_name)
        setSelectedCompany(rowData.company)
        setdepartment(rowData.department)
        setrelatedPersonlist(rowData.related_person)
        setSelectedGroupKey(rowData.group)
        setSelectedCategoryKey(rowData.category)
        setrolesval(rowData.role)
        // setValue('label', rowData.label);
        topRef.current?.scrollIntoView({ behavior: 'smooth' });


        const matchedLabel = addressLabels.find(l => l.id === rowData.label || l.name === rowData.label);
        setSelectedLabel1(matchedLabel || null);
        // Disable useEffect-triggered API calls
        skipEffectsDuringEdit.current = true;

        // Step 1: Set selected country
        const selectedCountryObj = addCountries.find(
            (c) => c.name === rowData.country_name
        );
        setSelectedCountry(selectedCountryObj);

        if (!selectedCountryObj) return;

        // Step 2: Get states and wait for them to populate
        const stateResponse = await axios.get(`/api/v1/get-all-states/?country_id=${selectedCountryObj.id}`);
        const transformedStates = stateResponse.data.results.map((state) => ({
            name: state.name,
            id: state.state_id,
        }));
        setAddStates(transformedStates);

        const selectedStateObj = transformedStates.find(
            (s) => s.name === rowData.state_name
        );
        setSelectedState(selectedStateObj);

        if (!selectedStateObj) return;

        // Step 3: Get cities and wait for them to populate
        const cityResponse = await axios.get(`/api/v1/get-all-cities/?state_id=${selectedStateObj.id}`);
        const transformedCities = cityResponse.data.results.map((city) => ({
            name: city.name,
            id: city.city_id,
        }));
        setAddCities(transformedCities);

        const selectedCityObj = transformedCities.find(
            (c) => c.name === rowData.city_name
        );
        setSelectedCity(selectedCityObj);

        // Re-enable useEffect after edit
        skipEffectsDuringEdit.current = false;

    }

    const [errormsgstrete, seterrormsgstrete] = useState("");
    const [errormsgstrete1, seterrormsgstrete1] = useState("");
    const [errormsgpost, seterrormsgpost] = useState("");
    const [errormsglabel, seterrormsglabel] = useState("");

    const handleSubmituser = () => {
        let isValid = true;

        // Reset all error messages first
        seterrormsgstrete("");
        seterrormsgstrete1("");
        seterrormsgpost("");

        const alphabetRegex = /^[A-Za-z0-9\s\-_,./]+$/;
        const postalCodeRegex = /^[1-9][0-9]{5}$/;

        if (!street1.trim()) {
            seterrormsgstrete("Street 1 is required.");
            isValid = false;
        } else if (!alphabetRegex.test(street1.trim())) {
            seterrormsgstrete("Street 1 must contain only alphabets and spaces.");
            isValid = false;
        }
        if (!street2.trim()) {
            seterrormsgstrete1("Street 2 is required.");
            isValid = false;
        } else if (!alphabetRegex.test(street2.trim())) {
            seterrormsgstrete1("Street 1 must contain only alphabets and spaces.");
            isValid = false;
        }

        if (!postalCode.trim()) {
            seterrormsgpost("Postal Code is required.");
            isValid = false;
        } else if (!postalCodeRegex.test(postalCode.trim())) {
            seterrormsgpost("Postal Code must be 5 or 6 digits and only numbers.");
            isValid = false;
        }

        if (!selectedLabel1) {
            seterrormsglabel("Label is required.");
            isValid = false;
        }

        if (!isValid) {
            return; // Don't close modal if there's any validation error
        }

        // If valid, set address and close modal
        setAddress([
            street1 || "",
            street2 || "",
            selectedCity?.name || selectedCity || "",
            selectedState?.name || selectedState || "",
            selectedCountry?.name || selectedCountry || "",
            postalCode || "",
            selectedLabel1?.name || selectedLabel1 || ""
        ].filter(Boolean));

        setVisible(false); // Close the modal
    };

    const [errorhandling, seterrorhandling] = useState("")
    const [errorhandlinguser, seterrorhandlinguser] = useState("")
    const addNewUser = async (data) => {
        setIsLoading(true);
        try {
            const response = await axios.post(`/api/v1/users/`, data);
            //console.log("response", response)
            if (response.status === 201 || response.status === 200) {
                setIsLoading(false);
                const page = Math.floor(first / rows) + 1
                fetchUserManagementDetails(page, rows,);
                setFormVisible(false)
                setsmcreate("User Added Successfully")
                setSmShowcreate(true)
                resetForm();
            }
        } catch (error) {
            //console.error(error);
            setIsLoading(false);

            if (error.response.data.user_id || error.response.data.email) {
                seterrorhandling(error.response.data.user_id || error.response.data.email)

            }
            if (error.response.data.error) {
                seterrorhandlinguser(error.response.data.error)

            }
        }
    }
    const editNewUser = async (id, data) => {
        console.log("eeeeeeeeeeee",data)
        const role ={
            role: data.role,
        }
        setIsLoading(true);
        try {
            const response = await axios.put(`/api/v1/users/${id}/`, role);
            //console.log("response", response)
            if (response.status === 201 || response.status === 200) {
                setFormVisible(false)
                const page = Math.floor(first / rows) + 1
                fetchUserManagementDetails(page, rows,type, companyId);
                resetForm();
                setIsLoading(false);
                setsmcreate("Edited")
                setSmShowcreate(true)
            }
        } catch (error) {
            //console.error(error);

            setIsLoading(false);
            if (error.response.data.user_id || error.response.data.email) {
                seterrorhandling(error.response.data.user_id || error.response.data.email)

            }

            if (error.response.data.error) {
                seterrorhandlinguser(error.response.data.error)

            }
        }
    }
    // Handle form submit (Add or Edit user)
    const handleFormSubmit = (data) => {
        data.role = rolesval
        editNewUser(isEditMode, data);
        //console.log("data", data);
        // data.street_address = street1;
        // data.street_address_line_2 = street2;
        // data.pincode = postalCode;
        // // data.label = selectedLabel1?.name;
        // data.label = selectedLabel1?.id;
        // data.state = selectedState?.id;
        // data.city = selectedCity?.id;
        // data.country = selectedCountry?.id;
        // data.category = selectedCategoryKey
        // data.group = selectedGroupKey;
        // data.department = department;
        // data.related_person = relatedPersonlist;
        
        if (isEditMode) {
            // Update existing user
            editNewUser(isEditMode, data);
        } else {
            // Add new user
            addNewUser(data)
        }
        // resetForm()
    }

    // Handle delete
    const handleDeleteUser = async () => {
        let id = deleteRowIduser

        try {
            const response = await axios.delete(`/api/v1/users/${id}/`);
            if (response.status === 200) {
                // Optionally, show a success message
                const page = Math.floor(first / rows) + 1
                fetchUserManagementDetails(page, rows,); // Refresh the user list
                setSmShowuser(false)
                setSuccessAlert(true)
            }
        } catch (error) {

            console.error("Error deleting user:", error);
            // Optionally, show an error notification
        }
    };


    // const fetchAlluserlist = async () => {
    //     try {
    //         const response = await axios.get(`/api/v1/get-all-recruiters/`)
    //         const transformedDataroles = response.data.results.map((city) => ({
    //             name: city.first_name + ' ' + city.middle_name + ' ' + city.last_name,
    //             id: city.id,
    //         }));
    //         setavailableOptions(transformedDataroles);

    //     }
    //     catch (error) {
    //         //console.log('error occured ', error.message)
    //     }
    // }
    // Handle delete

    const formatCategories = (categories) => {
        return categories.map((cat) => ({
            key: String(cat.category_id),
            label: cat.name,
            children: cat.subcategories ? formatCategories(cat.subcategories) : [],
        }));
    };
    const getcategoriesitem = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-categories/`, {});
            if (response.data && response.data.results) {
                const formatted = formatCategories(response.data.results);
                setcategoriesitem(formatted);
            }
        } catch (error) {
        }
    };
    const formatGroups = (groups) => {
        return groups.map((grp) => ({
            key: String(grp.group_id),
            label: grp.name,
            children: grp.subgroups ? formatGroups(grp.subgroups) : [],
        }));
    };
    const getgroupsitemsub = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-groups/`, {
            });
            if (response.data && response.data.results) {
                const formattedGroups = formatGroups(response.data.results);
                setgroupitem(formattedGroups);
            }

        } catch (error) {

        }
    };
    const onPageChangeuser = (event) => {
    
        const newPage = Math.floor(event.first / event.rows) + 1;

        dispatch(setPageData({
            first: event.first,
            rows: event.rows,
            totalRecords: totalRecords,
        })); 

        fetchUserManagementDetails(newPage, event.rows, type, companyId);
    };


    const fetchUserManagementDetails = async (page, size, type, companyId, search = "") => {
  setLoading(true);
  try {
    let url = `/api/v1/users/?page=${page}&size=${size}&company_id=${companyId}`;
    if (search) {
      url += `&search=${search}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      const responseData = response.data.results;
      setUserList(responseData);
      setTotalRecordsuser(response.data.count || 0);
      dispatch(
        setPageData({
          first: (page - 1) * size,
          rows: size,
          totalRecords: response.data.count || 0,
        })
      );
    }
  } catch (error) {
    setLoading(false);
  } finally {
    setLoading(false);
  }
};


    useEffect(() => {
        getgroupsitemsub();
    }, []);

    useEffect(() => {
        const page = Math.floor(first / rows) + 1
        fetchUserManagementDetails(page, rows, type, companyId);


    }, [first, rows, type, companyId]);

    useEffect(() => {
        getaddCountries()
        getcategoriesitem()
        fetchUserRoles();
        fetchAllCompanies();
        fetchAllDepartments();

    }, [])

    useEffect(() => {
        if (skipEffectsDuringEdit.current) return;
        if (selectedCountry) {
            getaddStates(selectedCountry.id);
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (skipEffectsDuringEdit.current) return;
        if (selectedState) {
            getaddCities(selectedState.id);
        }
    }, [selectedState]);
    /////////////////////////////////////////////////////naveen pss////////////////////////////

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };

    const handleCompanyChange = (company) => {
        // setSelectedCompany(company);
        const page = Math.floor(first / rows) + 1
        if (company?.company_id) {
            setCompanyId(company?.company_id);
             setSearchQuery("");
            fetchUserManagementDetails(page, rows, type, company.company_id)
            // getDesignation(company.company_id);
        }
    };
const topRef = useRef(null);

    return (
        <React.Fragment>
            <Container fluid={true}>
                <div className="">
                    <div className="container-fluid mt-3 ps-3">
                        <div className="usermanagement-main ">
                            {/* start user management */}

                            <div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 className="heading-sz">User</h3>
                                    <div className="d-flex justify-content-end align-items-center">
                                        <div className="field mb-2 me-2">
                                            <label htmlFor="role_id">Select Company<span className="text-danger">*</span></label>

                                            <CompanySelector onCompanyChange={handleCompanyChange} />
                                             
                                            {/* <Input className="mb-3" type="select" id="CompanySelInput" name="CompanySelInput">
                                                <option selected>Select Company</option>
                                                <option value="1">PSS</option>
                                                <option value="2">VGTS</option>
                                                <option value="3">Varun Digital</option>
                                                <option value="4">MSCD</option>
                                            </Input>
                                            {errors.role_id && <small className="text-danger">{errors.role_id.message}</small>} */}
                                        </div>
                                        {/* <div className="me-2 mt-2" style={{ width: "250px", }}>
                                            <InputGroup>
                                                <Input
                                                style={{ fontSize: "15px"}}
                                                placeholder="Search Name or Email..."
                                                // value={searchQuery}
                                                // onChange={handleSearchChange}
                                                // onKeyDown={e => {
                                                //     if (e.key === "Enter")
                                                //     getCandidates(companyId, 1, 10, searchQuery)
                                                // }}
                                                />
                                                {/* {searchQuery !== "" && (
                                                <InputGroupText
                                                    style={{
                                                    cursor: "pointer",
                                                    background: "transparent",
                                                    borderLeft: "none",
                                                    }}
                                                    onClick={() => {
                                                    setSearchQuery("")
                                                    getCandidates(companyId, 1, 10, "")
                                                    }}
                                                >
                                                    <FaTimes
                                                    style={{ fontSize: "14px", color: "#6c757d" }}
                                                    />
                                                </InputGroupText>
                                                )} */}
                        
                                                {/* <Button
                                                style={{fontSize: "15px"}}
                                                className="btn searchIconBtn"
                                                onClick={() =>
                                                    getCandidates(companyId, 1, 10, searchQuery)
                                                }
                                                >
                                                <i className="fa fa-search" />
                                                </Button>
                                            </InputGroup> */}
                                        {/* </div>  */}
                                      <div className="me-2 mt-2" style={{ width: "250px" }}>
  <InputGroup>
    <Input
      style={{ fontSize: "15px" }}
      placeholder="Search Name or Email..."
      value={searchQuery}
      onChange={(e) => {
        setSearchQuery(e.target.value);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          const page = Math.floor(first / rows) + 1;
          fetchUserManagementDetails(page, rows, type, companyId, searchQuery);
        }
      }}
      onKeyUp={(e) => {
        // If the search field is empty after a key press (e.g., backspace), trigger the API call
        if (searchQuery === "") {
          const page = Math.floor(first / rows) + 1;
          fetchUserManagementDetails(page, rows, type, companyId, "");
        }
      }}
    />
    {searchQuery !== "" && (
      <InputGroupText
        style={{
          cursor: "pointer",
          background: "transparent",
          borderLeft: "none",
        }}
        onClick={() => {
          setSearchQuery("");
          const page = Math.floor(first / rows) + 1;
          fetchUserManagementDetails(page, rows, type, companyId, "");
        }}
      >
        <FaTimes style={{ fontSize: "14px", color: "#6c757d" }} />
      </InputGroupText>
    )}
    <Button
      style={{ fontSize: "15px" }}
      className="btn searchIconBtn"
      onClick={() => {
        const page = Math.floor(first / rows) + 1;
        fetchUserManagementDetails(page, rows, type, companyId, searchQuery);
      }}
    >
      <i className="fa fa-search" />
    </Button>
  </InputGroup>
</div>




                                        {/* <div className="field mb-2">
                                            <label htmlFor="role_id">Employees<span className="text-danger">*</span></label>
                                            <Input className="mb-3" type="select" id="EmployeeSelInput" name="EmployeeSelInput">
                                                <option selected>Select Employee</option>
                                                <option value="1">Aliveni</option>
                                                <option value="2">Murali</option>
                                                <option value="3">Sai Kumar</option>
                                                <option value="4">Chandra Shekar</option>
                                            </Input>
                                            {errors.role_id && <small className="text-danger">{errors.role_id.message}</small>}
                                        </div> */}
                                    </div>

                                    {/* Add User Button commented for now in standalone we can add*/}
                                    {/* <div className="mb-3">
                                        <Button
                                            label="Add User"
                                            icon="pi pi-user"
                                            className="p-button-primary"
                                            onClick={() => {
                                                setSelectedCountry("");
                                                setSelectedState("");
                                                setSelectedCity(""); setFormVisible(true); setStreet1(""); setAddress(""); setSelectedLabel1(""); setStreet2(""); setPostalCode(""); reset(); setdepartment(""); setrolesval(); setSelectedCategoryKey(); setSelectedGroupKey()
                                            }}
                                        />
                                    </div> */}
                                </div>

                                {/* Form Section (Visible only when formVisible is true) */}
                                {formVisible && (
                                    <div ref={topRef}>
                                    <form className="mb-3 p-3 border rounded" onSubmit={handleSubmit(handleFormSubmit)}>
                                        {/* <h4>{isEditMode ? "Edit User" : "Add User"}</h4> */}
                                        {/* <div className="field mb-2">
                                            <label htmlFor="user_id">Username <span className="text-danger">*</span></label>
                                            <InputText id="user_id" className="w-full" placeholder="Username" {...register("user_id", {
                                                required: "Username is required",
                                                pattern: onlyAlphabetsandSpaces,
                                                minLength: MinLengthValidation(3),
                                                maxLength: MaxLengthValidation(100)

                                            })} onKeyUp={() => { trigger("user_id"); seterrorhandlinguser(""); seterrorhandling("") }} />
                                            {errors.user_id && <small className="text-danger">{errors.user_id.message}</small>}
                                        </div> */}

                                        {/* <div className="field mb-2">
                                            <label htmlFor="password">Password<span className="text-danger">*</span></label>
                                            <div className="p-inputgroup w-full">
                                                <InputText
                                                    id="password"
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Password"
                                                    className="w-full"
                                                    {...register("password", {
                                                        required: "Password is required",
                                                        pattern: passwordPattern,
                                                        minLength: MinLengthValidation(6),
                                                        maxLength: MaxLengthValidation(16),
                                                    })} onKeyUp={() => { trigger("password"); }}
                                                />
                                                <span
                                                    className="p-inputgroup-addon"
                                                    onClick={togglePassword}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {showPassword ? <Eye size={16} /> : <EyeOff size={16} />}
                                                </span>
                                            </div>
                                            {errors.password && (
                                                <small className="text-danger">{errors.password.message}</small>
                                            )}
                                        </div> */}


                                        <div className="field mb-2">
                                            <label htmlFor="email">Email<span className="text-danger">*</span></label>
                                            <InputText id="email" className="w-full" placeholder="Email"
                                                {...register("email", {
                                                    required: "This field is required",
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.com$/,
                                                        message: "Please enter a valid email ID",
                                                    },
                                                    onChange: (event) => event.target.value = event.target.value.toLowerCase()

                                                })}
                                                onKeyUp={() => { trigger("email"); seterrorhandlinguser(""); seterrorhandling("") }} />
                                            {errors.email && <small className="text-danger">{errors.email.message}</small>}
                                        </div>
                                        {/* Chandu */}


                                        <div className="field mb-2" id="RoleDropdown">
                                            <label htmlFor="role_id">Role<span className="text-danger">*</span></label>
                                            <Dropdown
                                                value={rolesval}
                                                onChange={(e) => setrolesval(e.value)}
                                                options={userRoles}
                                                optionLabel="name"
                                                optionValue="id"
                                                filter
                                                className="w-full activejobdrop bodercolornone  "
                                                placeholder="Select Role"
                                            />
                                            {errors.role_id && <small className="text-danger">{errors.role_id.message}</small>}
                                        </div>

                                        {/* <div className="field mb-2">
                                            <label htmlFor="first_name">First Name<span className="text-danger">*</span></label>
                                            <InputText id="first_name" className="w-full" placeholder="Enter first name" {...register("first_name", { required: "First name is required", pattern: { value: /^[A-Za-z][A-Za-z-\s&]+$/, message: "Only alphabets and spaces allowed" } })} />
                                            {errors.first_name && <small className="text-danger">{errors.first_name.message}</small>}
                                        </div>
                                        <div className="field mb-2">
                                            <label htmlFor="middle_name">Middle Name</label>
                                            <InputText id="middle_name" className="w-full" placeholder="Enter middle name" {...register("middle_name",)} />
                                        </div>
                                        <div className="field mb-2">
                                            <label htmlFor="last_name">Last Name <span className="text-danger">*</span></label>
                                            <InputText id="last_name" className="w-full" placeholder="Enter last name" {...register("last_name", { required: "Last name is required", pattern: { value: /^[A-Za-z][A-Za-z-\s&]+$/, message: "Only alphabets and spaces allowed" } })} />
                                            {errors.last_name && <small className="text-danger">{errors.last_name.message}</small>}
                                        </div>
                                        <div className="field mb-2">
                                            <label htmlFor="phone_number">Phone Number<span className="text-danger">*</span></label>
                                            <input type='text' className='addPhoneInput form-control' name='addPhoneInput' id='addPhoneInput'
                                                placeholder='Phone' autoComplete="off"
                                                {...register("phone_number", {
                                                    required: "This field is required",
                                                    pattern: {
                                                        value:
                                                            /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/,
                                                        message: "Please enter a valid mobile number.",
                                                    },
                                                    minLength: {
                                                        value: 10,
                                                        message: "Please enter Min and Max 10 digits ",
                                                    },
                                                    maxLength: {
                                                        value: 10,
                                                        message: "Please enter Min and Max 10 digits ",
                                                    },
                                                })}
                                                onKeyUp={(e) => {
                                                    trigger("phone_number");

                                                }}
                                            />

                                            {errors.phone_number && <small className="text-danger">{errors.phone_number.message}</small>}
                                        </div>
                                        <div className="field mb-2">
                                            <label htmlFor="job_title">Job Title<span className="text-danger">*</span></label>
                                            <InputText id="job_title" className="w-full" placeholder="Enter job title" {...register("job_title", {
                                                required: "Job Title is required",
                                                pattern: onlyAlphabetsandSpaces,
                                                minLength: MinLengthValidation(3),
                                                maxLength: MaxLengthValidation(100)
                                            })} onKeyUp={() => { trigger("job_title"); }} />
                                            {errors.job_title && <small className="text-danger">{errors.job_title.message}</small>}
                                        </div> */}
                                        {/* <div className="field mb-2">
                              <label htmlFor="company">Company</label>
                              <Dropdown
                                id="company"
                                value={selectedCompany} // This binds the selected company id
                                options={companies} // This binds the companies array
                                onChange={(e) => setSelectedCompany(e.value)} // Update the selected company id
                                placeholder="Select Company"
                                optionLabel="name" // Display company name
                                optionValue="id" // Use company id as the value for selection
                                filter // Enable search functionality
                                filterBy="name" // Search by company name
                                className="w-full activejobdrop"
                              />
                              {errors.company && <small className="text-danger">{errors.company.message}</small>}
                            </div> */}
                                        {/* <div className="field mb-2">
                                            <label htmlFor="department">Department</label>
                                            <Dropdown
                                                id="company"
                                                value={department} 
                                                options={departmentslist} 
                                                onChange={(e) => setdepartment(e.value)} 
                                                placeholder="Select Company"
                                                optionLabel="name" 
                                                optionValue="id" 
                                                filter 
                                                filterBy="name" 
                                                className="w-full activejobdrop"
                                            />
                                            {errors.department && <small className="text-danger">{errors.department.message}</small>}
                                        </div>

                                        <div className="field mb-2">
                                            <label htmlFor="department">Reporting Person</label>

                                            <Dropdown
                                                id="company"
                                                value={relatedPersonlist} // This binds the selected person
                                                options={relatedPerson} // This is the list of options
                                                onChange={(e) => setrelatedPersonlist(e.value)} // Set selected person
                                                placeholder="Select Reporting"
                                                optionLabel="name" // Display company name
                                                optionValue="id" // Use company id as the value for selection
                                                filter // Enable search functionality
                                                filterBy="name" // Search by company name
                                                className="w-full activejobdrop"
                                            />

                                            {errors.department && <small className="text-danger">{errors.department.message}</small>}
                                        </div>
                                        <div className="field mb-2">
                                            <label htmlFor="category">Category</label>
                                            <TreeSelect
                                                value={selectedCategoryKey}
                                                onChange={(e) => setSelectedCategoryKey(e.value)}
                                                options={categoriesitem}
                                                optionLabel="name"
                                                optionValue="id"
                                                filter
                                                className="w-full activejobdrop"
                                                placeholder="Select Category"
                                            />
                                            {errors.category && <small className="text-danger">{errors.category.message}</small>}
                                        </div>
                                        <div className="field mb-2">
                                            <label htmlFor="group">Groups</label>
                                            <TreeSelect
                                                value={selectedGroupKey}
                                                onChange={(e) => setSelectedGroupKey(e.value)}
                                                options={groupitem}
                                                optionLabel="name"
                                                optionValue="id"
                                                filter
                                                className="w-full"
                                                placeholder="Select Group"
                                            />
                                            {errors.group && <small className="text-danger">{errors.group.message}</small>}
                                        </div> */}

                                        <small className='form-text text-danger'>{errorhandling}</small>
                                        <small className='form-text text-danger'>{errorhandlinguser}</small>
                                        <div className="d-flex justify-content-start mt-4">
                                            <Button
                                                label={isEditMode ? "Update" : "Save"}
                                                disabled={isLoading}
                                                icon="pi pi-save"
                                                className="p-button-primary me-2  btn btn-primary waves-effect" style={{ color: "white"}}
                                                type="submit"
                                            // onClick={handleFormSubmit}
                                            />
                                            <Button
                                                label="Cancel"
                                                icon="pi pi-times"
                                                className="p-button-danger btn btn-primary waves-effect" style={{ color: "white"}}
                                                onClick={resetForm} // Cancel action will reset and hide the form
                                            />
                                        </div>
                                    </form>
                                    </div>
                                )}

                                {/* DataTable Section */}
                                
                                {loading ? (
                                
                                    <OrgTableShimmer columns={6} rows={7} titleWidth="210px" />
                                ) : (
                                    <DataTable
                                        ref={dt}
                                        value={userList}
                                        scrollable scrollHeight="400px"
                                        loading={loading}
                                        paginator
                                        lazy
                                        first={first}
                                        rows={rows}
                                        totalRecords={totalRecords}
                                        onPage={onPageChangeuser}
                                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        rowsPerPageOptions={[5, 10, 20, 50, totalRecords]} 
                                        dataKey="id"
                                        id="UserManagement_TableView"
                                    >
                                        {/* <Column field="first_name" header="First Name" /> */}
                                        <Column
                                            header="Name"
                                            // sortable
                                            style={{ minWidth: "14rem" }}
                                            body={rowData => {
                                                const fullName = [
                                                rowData.first_name,
                                                rowData.middle_name,
                                                rowData.last_name,
                                                ]
                                                .filter(Boolean)
                                                .join(" ")
 
                                                return (
                                                <span title={fullName}>
                                                    {fullName || "—"}
                                                </span>
                                                )
                                            }}
                                            // filter
                                            // filterPlaceholder="Search by name"
                                            // filterMatchMode="contains"
                                            filterField="first_name"
                                            />
 
                                        <Column field="email" header="Email" />
                                        <Column field="role_name" header="Role" />
                                        {/* <Column field="is_manager" header="Is Manager" body={(rowData) => {
                                            const status = rowData.is_manager; // Assuming 'Status' is the field name in your data
                                            let badgeClass = '';
                                            // Define the badge style based on the status value
                                            switch (status) {
                                                case true:
                                                    badgeClass = 'p-badge-success';
                                                    break;
                                                case false:
                                                    badgeClass = 'p-badge-danger';
                                                    break;
                                                default:
                                                    badgeClass = 'p-badge-outline';
                                                    break;
                                            }
                                            return (
                                                <span className={`p-badge ${badgeClass}`} style={{ borderRadius: '50px', padding: '5px 10px' }}>
                                                    {status ? 'Yes' : 'No'}
                                                </span>
                                            );
                                        }} /> */}
                                        <Column field="date_joined" header="Joined Date" body={(rowData) => rowData.date_joined ? moment(rowData.date_joined).format('YYYY-MM-DD') : ''} />
                                        {/* Actions Column for Edit and Delete */}
                                        <Column
                                            style={{ width: "10%" }}
                                            body={(rowData, { rowIndex }) => (
                                                <div className="d-flex">
                                                    <Button
                                                        icon="pi pi-pencil"
                                                        className="p-button-text p-button-sm me-2"
                                                        onClick={() => {
                                                            reset()
                                                            handleEditUser(rowData)
                                                            setFormVisible(true)
                                                            seterrorhandlinguser("")
                                                        }}
                                                    />
                                                    {/* <Button
                                                        icon="pi pi-trash"
                                                        className="p-button-text p-button-sm p-button-danger"
                                                        onClick={() => {
                                                            setSmShowuser(true);
                                                            setDeleteRowIDuser(rowData?.id)
                                                        }}
                                                    /> */}
                                                </div>
                                            )}
                                            header="Actions"
                                        />
                                    </DataTable>
                                )}
                            </div>

                            {/* end user management */}

                        </div>
                    </div>
                </div>
            </Container>

            {/* <Modal size="md" show={smShow} onHide={() => setSmShow(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Delete</h1></Modal.Header>
                <div className="text-center m-3 text-danger">  </div>
                <h4 className="text-center m-2"> Are you sure you want to delete this </h4>
                <div className="text-center m-3">
                    <Button className="btn btn-primary m-1" onClick={() => setSmShow(false)} >Cancel</Button>
                    <button className="btn btn-primary m-1" onClick={deleteHandler}> Delete </button>
                </div>
            </Modal> */}
            <Modal size="md" show={successAlert} onHide={() => setSuccessAlert(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Success</h1></Modal.Header>
                <div className="text-center m-3"> </div>
                <h4 className="text-center">Deleted  Successfully</h4>
                <div className="text-center m-3">
                    <button className="btn btn-primary" onClick={() => setSuccessAlert(false)} > OK </button>
                </div>
            </Modal>
            <Modal size="md" show={smShowuser} onHide={() => setSmShowuser(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Delete</h1></Modal.Header>
                <div className="text-center m-3 text-danger">  </div>
                <h4 className="text-center m-2"> Are you sure you want to delete this </h4>
                <div className="text-center m-3">
                    <Button className="btn btn-primary m-1" onClick={() => setSmShowuser(false)} >Cancel</Button>
                    <button className="btn btn-primary m-1" onClick={handleDeleteUser}> Delete </button>
                </div>
            </Modal>



            <Modal size="md" show={smShowcreate} onHide={() => setSmShowcreate(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 ">{smcreate}</h1></Modal.Header>
                <div className="text-center m-3 text-danger">  </div>
                <h4 className="text-center m-2"> {smcreate} Successfully  </h4>
                <div className="text-center m-3">
                    <Button className="btn btn-primary m-1" onClick={() => setSmShowcreate(false)} >ok</Button>

                </div>
            </Modal>

        </React.Fragment>
    )
}

export default User_managment;